import React from 'react';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { history } from './shared/configure-store';
import Navbar from "./components/container/navbar/global";
import Dashboard from './components/container/dashboard';
import Login from './components/container/login';
import Register from './components/container/register';
import Forgot from './components/container/forgot';
import Company from './components/container/company';
import Success from './components/container/company/success';
import Landing from './components/container/landing';
import Reservation from './components/container/reservation';
import ReservationSuccess from './components/container/reservation/success';
import ReservationNote from './components/container/reservation/note';
import NotFound from './components/container/not-found';
import { PrivateRoute, RedirectRoute } from './libraries/route-handling';
import ForgotSuccess from "./components/container/forgot/success";
import ForgotReset from "./components/container/forgot/reset";
import Pass from "./components/container/forgot/pass";

const Routes = ({store}) => (

    <Provider store={store}>

        <ConnectedRouter history={history}>
            <Navbar />
            {

                <Switch>

                    <RedirectRoute path="/login" component={Login}/>

                    <RedirectRoute path="/register" component={Register}/>

                    <RedirectRoute path="/forgot" component={Forgot}/>
                    <RedirectRoute path="/forgot-success" component={ForgotSuccess}/>
                    <RedirectRoute path="/forgot-reset" component={ForgotReset}/>
                    <RedirectRoute path="/reset-success" component={Pass}/>

                    <PrivateRoute path="/landing" component={Landing}/>
                    <PrivateRoute path="/company" component={Company}/>
                    <PrivateRoute path="/success" component={Success}/>
                    <PrivateRoute path="/reservation" component={Reservation}/>
                    <PrivateRoute path="/reservation-success/:id" component={ReservationSuccess}/>
                    <PrivateRoute path="/reservation-note/:id" component={ReservationNote}/>

                    <PrivateRoute path="/" component={Dashboard}/>

                    <Route component={NotFound}/>

                </Switch>

            }

        </ConnectedRouter>

    </Provider>

);

export default Routes;